import { useSelector } from 'react-redux';
import { selectWhitelabelFeatures } from '@/selectors/whitelabelSelectors';

/**
 * Return features from the initialized Provider, whose config already includes canonical defaults.
 */
function useWhitelabelFeatures() {
  return useSelector(selectWhitelabelFeatures);
}

export { useWhitelabelFeatures };

/** @deprecated Migrate to the named import before removing this compatibility alias. */
// oxlint-disable-next-line no-default-export -- Compatibility with default imports in open PRs
export default useWhitelabelFeatures;
